import LocalStorageService from '~services/LocalStorageService';

const BOTH_VALUE = 'both';

export const isAvailableDispatchMethod = (dispatchMethod) => {
  const currentMethod = LocalStorageService.getDispatchType();
  return dispatchMethod === currentMethod || dispatchMethod === BOTH_VALUE;
};
